import React, { useCallback, useEffect, useMemo, useState } from 'react';
import FlashNotificationContext from './FlashNotificationContext';
import { subscribeToNotifications } from './notificationService';

let nextNotificationId = 1;

const normalizeNotification = (message, severity) => ({
  id: nextNotificationId++,
  message: String(message || 'An unexpected error occurred.'),
  severity: ['success', 'error', 'warning', 'info'].includes(severity) ? severity : 'info',
});

const FlashNotificationProvider = ({ children }) => {
  const [notification, setNotification] = useState(null);

  const showFlashNotification = useCallback((message, severity = 'info') => {
    setNotification(normalizeNotification(message, severity));
  }, []);

  const hideFlashNotification = useCallback(() => {
    setNotification(null);
  }, []);

  useEffect(
    () => subscribeToNotifications((message, severity) => {
      setNotification(normalizeNotification(message, severity));
    }),
    []
  );

  const value = useMemo(
    () => ({ hideFlashNotification, notification, showFlashNotification }),
    [hideFlashNotification, notification, showFlashNotification]
  );

  return (
    <FlashNotificationContext.Provider value={value}>
      {children}
    </FlashNotificationContext.Provider>
  );
};

export default FlashNotificationProvider;
